var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostsettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2734 7.03125V1.75781H12.6953V7.03125C11.7245 7.03125 10.9375 7.81828 10.9375 8.78906V29.1211C10.9375 29.6065 11.331 30 11.8164 30H31.1523C31.6377 30 32.0312 29.6065 32.0312 29.1211V8.78906C32.0312 7.81828 31.2443 7.03125 30.2734 7.03125ZM37.3047 3.79471V2.75391C37.3047 2.26811 36.9116 1.875 36.4258 1.875C35.94 1.875 35.5469 2.26811 35.5469 2.75391V3.79471C34.5261 4.15875 33.7891 5.1252 33.7891 6.26953V17.6953C33.7891 18.6661 34.576 19.4531 35.5469 19.4531H37.3047C38.2755 19.4531 39.0625 18.6661 39.0625 17.6953V6.26953C39.0625 5.1252 38.3255 4.15875 37.3047 3.79471Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.1523 0H11.8164C11.3242 0 10.9375 0.38666 10.9375 0.878906V8.78906H32.0312V0.878906C32.0312 0.38666 31.6446 0 31.1523 0ZM15.332 5.27344C14.8398 5.27344 14.4531 4.88666 14.4531 4.39453C14.4531 3.90229 14.8398 3.51562 15.332 3.51562C15.8243 3.51562 16.2109 3.90229 16.2109 4.39453C16.2109 4.88666 15.8243 5.27344 15.332 5.27344ZM24.1211 5.27344H18.8477C18.3554 5.27344 17.9688 4.88666 17.9688 4.39453C17.9688 3.90229 18.3554 3.51562 18.8477 3.51562H24.1211C24.6133 3.51562 25 3.90229 25 4.39453C25 4.88666 24.6133 5.27344 24.1211 5.27344ZM27.6367 5.27344C27.1445 5.27344 26.7578 4.88666 26.7578 4.39453C26.7578 3.90229 27.1445 3.51562 27.6367 3.51562C28.129 3.51562 28.5156 3.90229 28.5156 4.39453C28.5156 4.88666 28.129 5.27344 27.6367 5.27344ZM27.6367 12.4219H18.8477C18.3619 12.4219 17.9688 12.815 17.9688 13.3008C17.9688 13.7866 18.3619 14.1797 18.8477 14.1797H27.6367C28.1225 14.1797 28.5156 13.7866 28.5156 13.3008C28.5156 12.815 28.1225 12.4219 27.6367 12.4219ZM27.6367 15.9375H15.332C14.8462 15.9375 14.4531 16.3306 14.4531 16.8164C14.4531 17.3022 14.8462 17.6953 15.332 17.6953H27.6367C28.1225 17.6953 28.5156 17.3022 28.5156 16.8164C28.5156 16.3306 28.1225 15.9375 27.6367 15.9375ZM27.6367 19.4531H15.332C14.8462 19.4531 14.4531 19.8462 14.4531 20.332C14.4531 20.8178 14.8462 21.2109 15.332 21.2109H27.6367C28.1225 21.2109 28.5156 20.8178 28.5156 20.332C28.5156 19.8462 28.1225 19.4531 27.6367 19.4531ZM27.6367 22.9688H15.332C14.8462 22.9688 14.4531 23.3619 14.4531 23.8477C14.4531 24.3335 14.8462 24.7266 15.332 24.7266H27.6367C28.1225 24.7266 28.5156 24.3335 28.5156 23.8477C28.5156 23.3619 28.1225 22.9688 27.6367 22.9688ZM33.7891 17.6953V23.1267C33.7891 24.9325 34.5238 26.7032 35.8044 27.9847C35.9692 28.1495 36.1923 28.2422 36.4258 28.2422C36.6592 28.2422 36.8824 28.1495 37.0472 27.9847C38.3277 26.7032 39.0625 24.9325 39.0625 23.1267V17.6953H33.7891Z",
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.9375,
    y: 0,
    width: 48.125,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 10.9375,
    y: 1.75781,
    width: 28.125,
    height: 30.2422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.82151,
    y1: -27.0492,
    x2: 45.2661,
    y2: -25.1783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 25,
    y1: 28.2422,
    x2: 25,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostsettings);
export default __webpack_public_path__ + "static/media/postsettings.c549feee5471ab64405c0b71568ce192.svg";
export { ForwardRef as ReactComponent };